/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
  				url 		=> router path
  				name 		=> name to display in sidebar
  				slug 		=> router path name
  				icon 		=> Feather Icon component/icon name
  				tag 		=> text to display on badge
  				tagColor 	=> class to apply on badge element
  				i18n 		=> Internationalization
  				submenu 	=> submenu of current item (current item will become dropdown )
  							NOTE: Submenu don't have any icon(you can add icon if u want to display)
  				isDisabled 	=> disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Version: 1.1
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
// 	{
// 		header: "Dados globais",
// 		i18n: "Painel"
// 	},
//   {
// 		url: null,
// 		name: "Ranking",
// 		slug: "ranking",
// 		icon: "BarChart2Icon",
// 		i18n: "Ranking",
// 		submenu: [
// 			{
// 				url: null,
// 				name: "zPoints",
// 				slug: "zpoints",
// 				i18n: "Analytics",
// 			},
// 			{
// 				url: null,
// 				name: "Quests",
// 				slug: "quests",
// 				i18n: "Quests",
//       },
// 			{
// 				url: null,
// 				name: "Conquistas",
// 				slug: "conquistas",
// 				i18n: "Conquistas",
// 			},
// 		]
// 	},
	{
		header: "Suas informações",
		i18n: "Painel"
	},
	{
		url: "/",
		name: "Resumo",
		slug: "home",
		icon: "HomeIcon",
	},
	{
		url: "/conquistas",
		name: "Conquistas",
		slug: "conquistas",
		icon: "AwardIcon",
    },
    {
		url: "/avaliaraula",
		name: "Avaliar Aula",
		slug: "avaliaraula",
		icon: "StarIcon",
	},
	// {
	// 	url: "/quests",
	// 	name: "Quests",
	// 	slug: "quests",
	// 	icon: "PocketIcon",
	// },
	// {
	// 	url: "/class-chat",
	// 	name: "Turma",
	// 	slug: "class-chat",
	// 	icon: "PocketIcon",
	// }
	// {
	// 	header: "Material acadêmico",
	// 	i18n: "Acadêmico"
	// },
	// {
	// 	url: null,
	// 	name: "Cursos",
	// 	slug: "cursos",
	// 	icon: "BookIcon",
	// },
	// {
	// 	url: null,
	// 	name: "Frequência",
	// 	slug: "frequencia",
	// 	icon: "CalendarIcon",
	// },
	// {
	// 	url: null,
	// 	name: "Turma",
	// 	slug: "turma",
	// 	icon: "FolderIcon",
	// }
]